//
//
//
//
//
//
//
//
//
//
//


import WaitingScreen from './components/scan/WaitingScreen.vue'
import DataScreen from './components/scan/DataScreen.vue'
import LoadingOverlay from './components/scan/LoadingOverlay.vue'
import { store } from '@/apis/scan'

export default {
    name: 'App',
    components: {
        WaitingScreen,
        DataScreen,
        LoadingOverlay
    },
    data() {
        return {
            currentScreen: 'waiting',
            loadingType: '',
            scannedData: null,
            scanInit: false,
        }
    },
    methods: {
        handleScanComplete(data) {
            this.scannedData = data
            this.currentScreen = 'data'
            this.scanInit = true;
        },
        handleGo() {
            this.currentScreen = 'loading'
            this.loadingType = 'go'
            //完成當前數據請求
            // 模擬API請求
            setTimeout(() => {
                try {
                    store({ barcode: this.scannedData.barcode }).then(res => {
                        console.log(`output->res`, res)
                        if (res.code !== 200) {
                            this.$message.error("生產訂單處理失敗")
                            return;
                        }
                        this.$message.success("生產訂單處理成功")
                    }).catch(error => { 
                        this.$message.error(`生產訂單處理失敗:${error}`)
                    })
                } catch (error) {
                    this.$message.error(`生產訂單處理失敗:${error}`)
                }
                setTimeout(() => {
                    //進行 WAIT GO.
                    this.loadingType = ''
                    this.currentScreen = 'waiting'
                }, 300);


                console.log(`output->this.scannedData`, this.scannedData)
            }, 1000)
        },
        handleNoGo() {
            this.currentScreen = 'loading'
            this.loadingType = 'no-go'

            // 模擬重新掃碼
            setTimeout(() => {
                console.log('Cas')
                this.currentScreen = 'waiting'
            }, 1000)
        }
    }
}
